/** This export is automatically generated */
export const gitHash = 'c4577399';
